import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';

interface ExperimentalMessage {
	messageTemplateId: string;
	statsigExperiment: string;
	statsigParameterName: string;
	statsigTestCohortPredicate: (experimentValue: boolean | string) => boolean;
}

export const EXPERIMENTAL_MESSAGES: ExperimentalMessage[] = [];

/**
 * Filters messages against the experimental message list.
 *
 * - Non-experimental messages always pass through.
 * - Experimental messages pass only when at least one matching experiment
 *   evaluates the user as in-cohort (i.e. `statsigTestCohortPredicate` returns true).
 */
export const filterExperimentalMessages = <T extends { messageTemplateId?: string }>(
	messages: T[],
): T[] => {
	return messages.filter((message) => {
		const experimentalMessages = EXPERIMENTAL_MESSAGES.filter(
			(exp) => exp.messageTemplateId === message.messageTemplateId,
		);

		// Non-experimental messages pass through
		if (experimentalMessages.length === 0) {
			return true;
		}

		// Message passes if any matching experiment says the user is in cohort
		return experimentalMessages.some((experimentalMessage) => {
			// oxlint-disable-next-line post-office/no-manual-in-app-experiments -- Legacy experiment handling is retained without migration.
			const experimentValue = FeatureGates.getExperimentValue<boolean>(
				experimentalMessage.statsigExperiment,
				experimentalMessage.statsigParameterName,
				false,
			);

			return experimentalMessage.statsigTestCohortPredicate(experimentValue);
		});
	});
};
